<template>
    <div id="sidebar-container" class="column left hide-scrollbar" >

        <div id="calendar">
            <div class="calendar-navigation-container">
                <calendar-navigation @select="selectDate" @calendarOpen="calendarState" :selected_date="selected_date" :future_days="1" :past_days="1"></calendar-navigation>
            </div>
        </div>
        
        <Timeframes v-if="bShowTimeframes" :summary="summary"></Timeframes>

    </div>
</template>

<script>
import { formatDate as formatReferenceDate } from '@/utils/dateUtils'
import CalendarNavigation from '@/components/layout/CalendarNavigation.vue'
import Timeframes from '@/components/domain/sales/timeframes.vue'

export default {
    name: 'Sidebar',
    props: { categories: { type: Object }, date: { type: String }, summary: { type: Object }, bShowTimeframes: { type: Boolean, default: true } },
    components: {
        CalendarNavigation,
        Timeframes
    },
    data() {
        return {
            selected_date: this.date,
            categorySelected: false,
            calendarIsVisible: false
        }
    },
    computed: {
        sortedCategories() {
            return Object.values(this.categories).sort((a, b) => parseInt(a.order) - parseInt(b.order))
        },
        category() {
            return this.$store.getters['production/getSelectedCategory']
        }
    },
    methods: {
        selectDate(date) {
            this.$emit('selectDate', date)
        },
        calendarState(show) {
            this.calendarIsVisible = show
        },
        formatDate(date) {
            return formatReferenceDate(date)
        },
        isValidDate(dateString) {
            return moment(dateString, 'YYYY-MM-DD', true).isValid()
        }
    },
    created() {},
    watch: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#sidebar-container {
    padding: 8px;
    height: 100%;
    position: relative;
    padding: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;

    $size-bolita: rem(18px);

    #calendar {
        width: 100%;
        height: 50px;
        margin-bottom: 8px;
    }
}
</style>

// PORTRAIT STYLES
<style lang="scss" scoped></style>
